import React, { Component } from 'react';
import ElementInfoAdapter from '@src/slide/application/service/edit-action-services/element-info';
import Cropable from '../../../../cropable';
import GraphicContent from '../../../../graphic-content';
import { omitStyle } from '@src/slide/infrastructure/module/independent/assert/get-set';
import omit from 'lodash/omit';
import { observer } from 'mobx-react';
import _has from 'lodash/has';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';

interface Props {
    element: IPictureModel;
    scale: number;
    rect?: IFrame;
    rotate?: number;
    relativeRotate?: number;
    relativeFlipH?: number;
    relativeFlipV?: number;
}
@observer
class ImageCropping extends Component<Props> {
    public render() {
        const elementModel = this.props.element;
        const elementProps = elementModel.props;


        const rectInfo: any = {
            ...this.props.rect,
        };

        // @ts-ignore
        rectInfo.srcRect = _has(elementModel, 'srcRect.t') ? elementModel.srcRect : elementModel.props.style.srcRect;

        const { width } = rectInfo;
        const { height } = rectInfo;
        const srcRect = (rectInfo?.srcRect)
            ? rectInfo.srcRect : elementProps.style.srcRect;
        const { src } = elementProps;

        const { pl, pr, pt, pb, rw, rh } = this.getCropComponentParams(width, height, srcRect);

        const size = {
            width: rectInfo.width,
            height: rectInfo.height,
        };

        const flip = {
            flipH: rectInfo.flipH,
            flipV: rectInfo.flipV,
        };

        return (
            <Cropable
                component={elementModel}
                rw={rw}
                rh={rh}
                pl={pl}
                pt={pt}
                pr={pr}
                pb={pb}
                src={src}
                flip={flip}
                width={width}
                height={height}
                scale={this.props.scale}
                rotate={this.props.rotate || 0}
                type={elementModel.type}
                relativeRotate={this.props.relativeRotate || 0}
                relativeFlipH={this.props.relativeFlipH || 0}
                relativeFlipV={this.props.relativeFlipV || 0}
                getCropSize={this.getCropSize.bind(this, rectInfo)}
                getSize={() => ElementInfoAdapter.sizeInfo(elementModel)}
                getFlip={() => ElementInfoAdapter.flipInfo(elementModel)}
                getOldSrcRect={this.getOldSrcRect.bind(this, rectInfo)}
                isCroping={true}
            >
                { this.renderForeground(size, src, rw, rh, pl, pt) }
            </Cropable>
        );
    }
    private getCropSize(rectInfo: any): any {
        const componentProps = this.props.element.props;

        const { width } = rectInfo;
        const { height } = rectInfo;
        const { left } = rectInfo;
        const { top } = rectInfo;
        const srcRect = (rectInfo?.srcRect)
            ? rectInfo.srcRect : componentProps.style.srcRect;

        const { pl, pr, pt, pb, rw, rh } = this.props.element.getImageSize()
            .getForegroundImageSize({ width, height, srcRect });

        return {
            width: rw,
            height: rh,
            left: left - pl,
            top: top - pt,
            aLeft: pl,
            aTop: pt,
            aRight: pr,
            aBottom: pb,
            centerX: (width / 2) + left,
            centerY: (height / 2) + top,
        };
    }

    private getOldSrcRect(rectInfo: any): any {
        const componentProps = this.props.element.props;
        return (rectInfo?.srcRect) ? rectInfo.srcRect : componentProps.style.srcRect;
    }

    private renderForeground = (size: any, src: any, rw: any, rh: any, pl: any, pt: any) => {
        const foregroundModel = {
            ...omit(omitStyle(this.props.element.props.style), 'width', 'height', 'border'),
            ...size,
            rotate: this.props.rotate,
        };
        const image: any = {};
        image.src = src;
        image.width = rw;
        image.height = rh;
        image.pl = pl;
        image.pt = pt;
        image.alpha = this.props.element.props.style.alpha;
        image.isForeground = true;
        const fillBackground: any = {};
        fillBackground.image = image;
        foregroundModel.fillBackground = fillBackground;
        // @ts-ignore
        if (this.props.element.props.syncLoad) {
            image.syncLoad = true;
        }

        return (
            <GraphicContent
                model={foregroundModel}
                relativeRotate={this.props.relativeRotate}
                relativeFlipH={this.props.relativeFlipH}
                relativeFlipV={this.props.relativeFlipV}
                pointerEvents={'none'}
                style={{ width: foregroundModel.width, height: foregroundModel.height, position: 'absolute' }} // 里层去掉了，由外层传递
                mkey={foregroundModel.key}
            />
        );
    };

    private getCropComponentParams(width: any, height: any, srcRect: any): any {
        const { pl, pr, pt, pb, rw, rh } = this.props.element.getImageSize()
            .getForegroundImageSize({ width, height, srcRect });
        return {
            pl: `${-pl}px`,
            pr: `${-pr}px`,
            pt: `${-pt}px`,
            pb: `${-pb}px`,
            rw: isNaN(rw) ? 0 : rw,
            rh: isNaN(rh) ? 0 : rh,
        };
    }
}

export default ImageCropping;
